/**
 * API CompagnonCPS
 * API pour le connecteur CompagnonCPS
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VitalePatient { 
    index: number;
    nom: string;
    prenom: string;
    dateNaissance: string;
    nir: string;
    nirCertifie?: string;
    codeRegime: number;
    codeCaisse: number;
    /**
     * Renvoyé seulement si le codeRegime est \'3\'
     */
    codeCentre?: number;
    numSerie: string;
}

